var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VbDemo',[_c('VbCard',[_c('chat',{model:{value:(_vm.chatMessages),callback:function ($$v) {_vm.chatMessages=$$v},expression:"chatMessages"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }